// extracted by css-extract-rspack-plugin
export default {"bottomDescriptionContainer":"SMchV"};